<ngx-loading [show]="isProcessing"></ngx-loading>

<div class="row">

  <div class="col-md-12">

    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-header text-center">
        <h3 class="box-title ">Cadastrar/Emitir RD</h3><br />
      </div>

      <div class="box-body">

        <form novalidate [formGroup]="form" id="form" (validSubmit)="submit()">

          <div class="row">

            <div class="col-md-7">

              <div class="form-row">

                <div class="col-md-3">
                  <div class="form-group">
                    <label for="nome">Número Seq</label>
                    <input class="form-control text-center" type="text" formControlName="rDNumeroSeq" readonly />
                  </div>
                </div>

                <div class="col-md-5">
                  <div class="form-group">
                    <label for="nome">Modelo RD</label>
                    <select for="" class="form-control" formControlName="rDModeloId" 
                    (change)="getNextRdNumeroSeq()" [ngClass]="{'h-error' : this.validaDataModeloRDUnico != ''}">
                      <option value="null">selecione</option>
                      <option *ngFor="let t of this.modelosRD" [value]="t.id">{{ t.nome }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label for="nome">Data</label>
                    <input class="form-control" type="date" formControlName="rDData" max="2999-12-31"
                      (change)="getNextRdNumeroSeq()" [ngClass]="{'h-error' : this.validaDataModeloRDUnico != ''}">
                  </div>
                </div>

                <div class="col-md-12 text-center" *ngIf="this.validaDataModeloRDUnico != ''">
                  <span class="text-danger pl-5">{{this.validaDataModeloRDUnico}}</span>
                </div>
              </div>

            </div>

            <div class="col-md-5">

              <div class="col-md-12">
                <fieldset style="height: 80px">
                  <legend class="w-auto text-center pl-2 pr-2">
                    Situação climática
                  </legend>

                  <div class="btn-group d-flex mb-2" role="group"
                    [ngClass]="{'h-error' : this.validaSituacaoClimatica != ''}">
                    <button type="button" class="btn p-0" (click)="changeSituacaoClimatica('B')" [ngClass]="{
                      'btn-info':
                        this.form.controls.condicaoClima.value == 'B',
                      'btn-light':
                        this.form.controls.condicaoClima.value != 'B'
                    }">
                      <div class="weather">
                        <img src="assets\images\weather\weather_sun.png" />
                        <span>Bom</span>
                      </div>
                    </button>

                    <button type="button" class="btn p-0" (click)="changeSituacaoClimatica('N')" [ngClass]="{
                      'btn-info':
                        this.form.controls.condicaoClima.value == 'N',
                      'btn-light':
                        this.form.controls.condicaoClima.value != 'N'
                    }">
                      <div class="weather">
                        <img src="assets\images\weather\weather_clouds.png" />
                        <span>Nublado</span>
                      </div>
                    </button>
                    <button type="button" class="btn p-0" (click)="changeSituacaoClimatica('C')" [ngClass]="{
                      'btn-info':
                        this.form.controls.condicaoClima.value == 'C',
                      'btn-light':
                        this.form.controls.condicaoClima.value != 'C'
                    }">
                      <div class="weather">
                        <img src="assets\images\weather\weather_rain.png" />
                        <span>Chuvoso</span>
                      </div>
                    </button>

                  </div>
                </fieldset>
                <div class="row" *ngIf="this.validaSituacaoClimatica !=''">
                  <div class="col-md-12 text-center">
                    <span class="text-danger pl-5">{{this.validaSituacaoClimatica}}</span>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <div class="row">

            <div class="col-md-6">

              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">Observação contratada</label>
                    <textarea rows="4" class="form-control" formControlName="obsContratada"
                      style="resize: none;"></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">Observação fiscalização</label>
                    <textarea rows="4" class="form-control" formControlName="obsFiscalizacao"
                      style="resize: none;"></textarea>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="divider"></div>

          <section class="text-center">
            <h5>Equipamentos RD</h5>


            <div class="bx-tb-default-t1 pre-scrollable" style="min-height: 320px; max-height: 320px;">
              <table class="table table-bordered">

                <thead class="thead-default">
                  <tr>
                    <th rowspan="2" class="wf250">Equipamentos</th>
                    <th colspan="2">Período Nomal</th>
                    <th colspan="2">Período Especial</th>
                    <th rowspan="2" class="wf90">Diária</th>
                    <th rowspan="2" class="wf90">Horas</th>
                    <th rowspan="2">OBS</th>
                  </tr>
                  <tr class="tr-bottom">
                    <th class="wf80">M</th>
                    <th class="wf80">T</th>
                    <th class="wf80">M</th>
                    <th class="wf80">T</th>
                  </tr>
                </thead>

                <tbody class="tbody-default">
                  <tr *ngFor="let e of this.rDEquipamentos" class="cp">
                    <td>{{e.nome}}</td>
                    <td *ngFor="let f of this.fieldsDetEquipamento">
                      <input type="text" [value]="e.rdDetsEquipamento[0][f]" class="form-control text-center cp"
                        digitOnly maxlength="3" (blur)="changeRDDetEquipamento(e.id, f, $event.target.value)" />
                    </td>
                    <td>
                      <input type="text" [value]="e.rdDetsEquipamento[0].observacao" class="form-control text-left cp"
                        (blur)="changeRDDetEquipamento(e.id, 'observacao', $event.target.value)" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </section>

        </form>

      </div>
    </div>

  </div>

</div>


<div class="row mt-2">

  <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
    <div class="box-body">
      <div class="row">
        <div class="col-md-2">
          <button type="button" class="btn btn-light btn-block" [disabled]="!this.autorizacoes?.podeListar"
            title="Pesquisar RDs" (click)="showModalPesquisarRD(modalPesquisaRD)">
            <span class="txt-blue"><i class="fa fa-search"></i></span><span class="pl-3">Pesquisar</span>
          </button>

        </div>

        <div class="col-md-3">
          <button type="button" class="btn btn-light btn-block" [disabled]="!this.autorizacoes?.podeIncluir"
            title="Reuso de dados RD existente" (click)="showModalReuseRD(modalReuseRD)">
            <span class="text-success"><i class="fa fa-refresh"></i></span><span class="pl-3">Reutilizar dados RD</span>
          </button>

        </div>

        <div class="col-md-2">
          <button type="button" class="btn btn-light btn-block"
            [disabled]="!this.autorizacoes?.podeListar || this.form.get('id').value == 0" title="Imprimir RD"
            (click)="imprimirRD(this.form.get('id').value)">
            <span class="txt-blue"><i class="fa fa-print"></i></span><span class="pl-3">Imprimir</span>
          </button>

        </div>

        <div class="col-md-1">
          <div class="d-flex justify-content-center">
            <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
          </div>
        </div>

        <div class="col-md-2">
          <button type="button" class="btn btn-light btn-block" (click)="reset()">Limpar</button>
        </div>


        <div class="col-md-2">
          <button type="submit" class="btn btn-block btn-shadow" form="form"
            [disabled]="(!(!this.isEditing && this.autorizacoes?.podeIncluir) && !(this.isEditing && this.autorizacoes?.podeAlterar)) 
            || this.validaDataModeloRDUnico != '' || this.isProcessing"
            [ngClass]="{'btn-primary': !this.isEditing, 'btn-warning': this.isEditing }">
            <span *ngIf="!this.isEditing">Cadastrar</span>
            <span *ngIf="this.isEditing">Editar</span>
          </button>

        </div>

      </div>
    </div>
  </div>
</div>





<ng-template #modalPesquisaRD let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Pesquisar RD</h4>
  </div>
  <div class="modal-body pt-0 mt-0 tarja-edit">


    <div class="row mt-3">

      <div class="col-md-1 box-left">
        <span class="material-icons icon-theme">
          search
        </span>
      </div>

      <div class="col-md-11">

        <div class="row">

          <div class="col-md-2 text-center">

          </div>

          <div class="col-md-6">

            <div class="row">

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Data Inicial</label>
                  <input class="form-control" type="date" id="inputDataInicio" max="2999-12-31"
                    [ngClass]="{'h-error' : validaDataInicio != ''}">
                  <div class="col-md-12 text-text">
                    <span *ngIf="validaDataInicio !=''" class="text-danger pl-5">{{this.validaDataInicio}}</span>
                  </div>
                </div>

              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Data Final</label>
                  <input class="form-control" type="date" id="inputDataTermino" max="2999-12-31"
                    [ngClass]="{'h-error' : validaDataTermino != ''}">
                  <div class="col-md-12 text-center">
                    <span *ngIf="validaDataTermino!=''" class="text-danger">{{this.validaDataTermino}}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="col-md-2 text-center">
            <div class="form-group">
              <label for="">&nbsp;</label>
              <button type="button" class="btn btn-primary btn-block" (click)="search()"><span
                  class="fa fa-search fa-lg"></span></button>
            </div>


          </div>

        </div>

        <div class="divider"></div>


        <div class="row">
          <div class="col-md-12 text-center text-muted fs12 mb-2">
            Selecione para editar
          </div>
        </div>

        <div class="bx-tb-default-t1 pre-scrollable" style="min-height: 470px; max-height: 470px;">
          <table class="table table-bordered">

            <thead class="thead-default">
              <tr>
                <th class="text-center w20p">Data</th>
                <th class="text-center w40p">Modelo RD / Prefixo</th>
                <th class="text-center w20p">Situação climática</th>
                <th class="text-center w20p">RD Nº Seq</th>
                <th>#</th>
                <th>#</th>
              </tr>
            </thead>

            <tbody class="tbody-default">
              <tr *ngFor="let rd of this.rds">

                <td class="text-center cp"  (click)="getById(rd.id)">{{ rd.rdData | date: 'dd/MM/yyyy' }}</td>
                <td class="text-center cp"  (click)="getById(rd.id)">{{rd.rdModelo.nome}} / {{ rd.rdModelo.prefixo }}</td>
                <td *ngIf="rd.condicaoClima == 'B'" class="text-center cp" (click)="getById(rd.id)">Bom</td>
                <td *ngIf="rd.condicaoClima == 'N'" class="text-center cp" (click)="getById(rd.id)">Nublado</td>
                <td *ngIf="rd.condicaoClima == 'C'" class="text-center cp" (click)="getById(rd.id)">Chuvoso</td>
                <td class="text-center cp" (click)="getById(rd.id)">{{rd.rdNumeroSeq}}</td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm cp" (click)="imprimirRD(rd.id)" title="imprimir RD">
                    <i class="fa fa-print text-primary" *ngIf="imprimindoRDId != rd.id"></i>
                    <i *ngIf="imprimindoRD && imprimindoRDId == rd.id" class="fa fa-spinner fa-spin fa-fw"></i>
                  </button>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm cp" (click)="getById(rd.id, true)" title="Reutilizar dados deste RD">
                    <i class="fa fa-refresh text-success"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


        <div *ngIf="this.rds.length != 0" class="pl-2 mt-2">
          <span class="pl-1">Total pesquisados: <b>{{ this.rds.length}}</b> </span>
        </div>


      </div>

    </div>

  </div>
  <div class="modal-footer">

    <div class="col-md-9"></div>
    <div class="col-md-3">
      <button type="button" class="btn btn-light btn-block" (click)="c('Close click')">Retornar</button>
    </div>

  </div>
</ng-template>





<ng-template #modalReuseRD let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Reutilizar dados de RD existente</h4>
  </div>
  <div class="modal-body pt-0 mt-0 tarja-edit">

    <div class="row mt-3 h330">

      <div class="col-md-1 box-left">
        <span class="material-icons icon-theme">
          sync
        </span>
      </div>

      <div class="col-md-11">


        <div class="row">

          <div class="col-md-10">

            <div class="row">

              <div class="col-md-5">
                <div class="form-group">
                  <label for="">Data</label>
                  <input class="form-control" type="date" id="inputDataRDExistente" max="2999-12-31"
                    [ngClass]="{'h-error' : validaDataRDExistente != ''}">
                  <div class="col-md-12 text-text">
                    <span *ngIf="validaDataRDExistente !=''"
                      class="text-danger pl-5">{{this.validaDataRDExistente}}</span>
                  </div>
                </div>

              </div>

              <div class="col-md-7">
                <div class="form-group">
                  <label for="nome">Modelo RD</label>
                  <select for="" class="form-control" id="rdModeloIdExistente"
                    [ngClass]="{'h-error' : validaRDIdExistente != ''}">
                    <option value=''>selecione</option>
                    <option *ngFor="let t of this.modelosRD" [value]="t.id">{{ t.nome }}</option>
                  </select>
                  <div class="col-md-12 text-text">
                    <span *ngIf="validaRDIdExistente !=''" class="text-danger pl-5">{{this.validaRDIdExistente}}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="col-md-2 text-center">
            <div class="form-group">
              <label for="">&nbsp;</label>
              <button type="button" class="btn btn-primary btn-block" (click)="searchRDExistente()"><span
                  class="fa fa-search fa-lg"></span></button>
            </div>


          </div>

        </div>

        <div class="divider mt-0"></div>


        <div class="bx-tb-default-t1" style="min-height: 220px; max-height: 220px;">
          <table class="table table-bordered" *ngIf="this.rdExistente">
            <tbody class="tbody-default reusoRD">
              <tr>
                <th>Data</th>
                <td>{{this.rdExistente?.rdData | date: 'dd/MM/yyyy'}}</td>
              </tr>
              <tr>
                <th>Modelo</th>
                <td>{{this.rdExistente?.rdModelo.nome}}</td>
              </tr>
              <tr>
                <th>Prefixo</th>
                <td>{{this.rdExistente?.rdModelo.prefixo}}</td>
              </tr>
              <tr>
                <th>Layout RPT</th>
                <td>{{this.rdExistente?.rdModelo.layoutRpt}}</td>
              </tr>
              <tr>
                <th>Situação climática</th>
                <td *ngIf="this.rdExistente?.condicaoClima == 'B'">Bom</td>
                <td *ngIf="this.rdExistente?.condicaoClima == 'N'">Nublado</td>
                <td *ngIf="this.rdExistente?.condicaoClima == 'C'">Chuvoso</td>
              </tr>

            </tbody>
          </table>
        </div>


      </div>



    </div>

  </div>

  <div class="modal-footer">
    <div class="col-md-6"></div>
    <div class="col-md-3">
      <button type="button" class="btn btn-light btn-block" (click)="c('Close click')">Retornar</button>
    </div>
    <div class="col-md-3">
      <button type="button" class="btn btn-primary btn-block" (click)="reuseRD()"
        [disabled]="!this.rdExistente">Reutilizar</button>
    </div>

  </div>
</ng-template>